import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  DatosAVerificarDTO,
  DatosVerificacionDTO,
  ObservatorioDTO, RechazarDTO, ResponseAprobarDTO, ResponseDescargaDTO,
  ResponseObservatorioDTO, ResponseRechazarDTO, ResponseVerificacionCorreoDTO,
  ResponseVerificacionDTO,
  SolicitudPjDTO
} from "../../modules/administracion-funcional/models/solicitud-pj-DTO";

@Injectable({
  providedIn: 'root'
})
export class GestionSolictudesService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/solicitudes-creacion-empresa';
  constructor(private http: HttpClient) { }
  // Se maneja con HttpParams, debido a que el filtro de NIT se envíanen la URL y es opcional
  solicitudes(
    nit?: string,
    orden?: string,
    page?: number,
    pageSize?: number,
    idEstado?: number) {
    let params = new HttpParams()
    if (nit) {
      params = params.set('nit', nit);
    }
    if (orden) {
      params = params.set('ordenTiempo', orden);
    }
    if (page) {
      params = params.set('page', page);
    }
    if (pageSize) {
      params = params.set('pageSize', pageSize);
    }
    if (idEstado !== undefined) {
      params = params.set('idEstado', idEstado.toString());
    }
    return this.http.get<SolicitudPjDTO>(
      `${this.apiUrl}${this.baseUrl}/listar`,
      { params }
    );
  }
  datosVerificacion(id: number) {
    return this.http.get<DatosVerificacionDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/datos-verificacion`
    );
  }
  verificar(id: number, datos: DatosAVerificarDTO) {
    return this.http.post<ResponseVerificacionDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/verificar`,
      datos
    );
  }

  guardarObservatorio(id: number, datos: ObservatorioDTO) {
    return this.http.post<ResponseObservatorioDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/guardar-datos-observatorio`,
      datos
    );
  }
  verificarCorreo(id: number, correo: { correoVerificacion: string }) {
    return this.http.post<ResponseVerificacionCorreoDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/verificar-correo-aprobacion`,
      correo
    );
  }

  rehazar(id: number, datos: RechazarDTO) {
    return this.http.post<ResponseRechazarDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/rechazar`,
      datos
    );
  }

  aprobar(id: number, datos: { correoVerificacion: string }) {
    return this.http.post<ResponseAprobarDTO>(
      `${this.apiUrl}${this.baseUrl}/${id}/aprobar`,
      datos
    );
  }

  descargar(archivos: { idsAnexos: number[] }) {
    return this.http.post<ResponseDescargaDTO>(
      `${this.apiUrl}${this.baseUrl}/documentos/descargar-multiples`,
      archivos
    );
  }
}
